import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

export default function MemberPage() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  if (!user) return null;

  return (
    <main className="pt-32 pb-20 px-6 md:px-12 max-w-[1400px] mx-auto" data-testid="member-page">
      <div className="meta-label text-cinabre">§ Espace membre</div>
      <h1 className="font-serif font-light text-6xl md:text-7xl leading-[0.9] tracking-tight mt-6">
        Bonjour, <em className="italic">{user.name || user.email}</em>.
      </h1>
      <p className="mt-6 text-fg/75 max-w-2xl leading-relaxed text-lg">
        Vous êtes officiellement membre du Fil du Midi. À venir : appels à participation artistes, avant-premières, réservations.
      </p>

      <div className="mt-16 grid md:grid-cols-3 gap-4">
        {[
          { t: "Appels à artistes", d: "Prochainement", tag: "V2" },
          { t: "Vernissages", d: "Prochainement", tag: "V2" },
          { t: "Adhésion", d: "Prochainement", tag: "V2" },
        ].map((c) => (
          <div key={c.t} className="border border-fg/15 p-8">
            <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-cinabre">{c.tag}</div>
            <div className="font-serif text-3xl mt-4">{c.t}</div>
            <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-fg/60 mt-2">{c.d}</div>
          </div>
        ))}
      </div>

      <button
        onClick={async () => { await logout(); nav("/"); }}
        className="btn-editorial ghost mt-16"
        data-testid="member-logout"
      >
        <LogOut size={14} /> Se déconnecter
      </button>
    </main>
  );
}
